import type {
  PaginatedAppInstallation,
  QueryAuthMemberAppInstallationsArgs,
} from '@tribeplatform/gql-client/types'
import type { PaginatedAppInstallationFields } from '@tribeplatform/gql-client/types/generated'

import {
  useInfiniteQuery,
  type UseInfiniteQueryOptions,
} from '../../lib/react-query/useInfiniteQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getAuthMemberAppInstallationsKey } from '../../utils/keys/app.key.js'

export const useAuthMemberAppInstallations = (options: {
  variables: QueryAuthMemberAppInstallationsArgs
  fields: PaginatedAppInstallationFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedAppInstallation>
}) => {
  const { useInfiniteQueryOptions, variables, fields = 'basic' } = options || {}
  const { client } = useTribeClient()
  const AuthMemberAppInstallationKey = getAuthMemberAppInstallationsKey({
    variables,
    fields,
  })

  return useInfiniteQuery<PaginatedAppInstallation>(
    AuthMemberAppInstallationKey,
    ({ pageParam: after }) =>
      client.query({
        name: 'authMemberAppInstallations',
        args: {
          variables: {
            ...variables,
            after,
          },
          fields,
        },
      }),
    useInfiniteQueryOptions,
  )
}
